import { Linkedin, UserCircle } from "lucide-react"
import Link from "next/link"
import { FaGithub } from "react-icons/fa"

import { Button } from "@/components/ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/components/ui/dropdown-menu"

export function AboutMeButton() {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button className="cursor-pointer px-8 py-4 rounded-md font-bold tracking-tight gap-2 group text-sm sm:text-base" variant="default">
                    Socials<UserCircle className="mr-2 h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56">
                <DropdownMenuItem>
                    <Link
                        href="https://www.linkedin.com/in/quoc-bui-368515163"
                        className="w-full flex items-center"
                        target="_blank"
                    >
                        <Linkedin className="mr-2 h-4 w-4 text-blue-600" />
                        LinkedIn
                    </Link>
                </DropdownMenuItem>
               
                <DropdownMenuItem>
                    <Link
                        href="https://github.com/quocbui0607"
                        className="w-full flex items-center"
                        target="_blank"
                    >
                        <FaGithub className="mr-2 h-4 w-4 text-black dark:text-white" />
                        Github
                    </Link>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
